function initAccordionGroup(group) {
  const accordions = group.querySelectorAll('.js-accordion');

  accordions.forEach((accordion, index) => {
    const toggleBtn = accordion.querySelector('.js-accordion-toggle');

    // Відкриваємо перший акордеон у групі
    if (index === 0) {
      accordion.classList.add('is-open');
      toggleBtn.setAttribute('aria-expanded', 'true');
    }

    toggleBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpening = !accordion.classList.contains('is-open');

      if (isOpening) {
        group.querySelectorAll('.js-accordion.is-open').forEach(openAccordion => {
          openAccordion.classList.remove('is-open');
          openAccordion.querySelector('.js-accordion-toggle').setAttribute('aria-expanded', 'false');
        });
      }

      accordion.classList.toggle('is-open', isOpening);
      toggleBtn.setAttribute('aria-expanded', isOpening);
    });
  });
}

export function initAccordion() {
  document.querySelectorAll('[data-accordion-group]').forEach(group => {
    initAccordionGroup(group);
  });
}
